import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { type DependenciesValues, buildDataSource, isDependenciesFilled } from '@/shared/helpers/DataSourceHelpers';

/**
 * Custom hook that generates a data source string based on provided dependencies and their values.
 *
 * @param baseDataSource - The base data source string that may contain placeholders for dependencies.
 * @param dependencies - An optional array of dependency keys that need to be replaced in the base data source.
 * @param dependenciesValues - An optional object mapping dependency keys to their corresponding values.
 * @returns An object containing:
 *   - `dependenciesFilled`: A boolean indicating whether all dependencies have been provided with values.
 *   - `dataSource`: The final data source string with dependencies replaced by their values, if all dependencies are filled. Otherwise, the base data source string. When no dependencies are provided, the base data source string is returned.
 */
export const useDataSource = (baseDataSource, dependencies, dependenciesValues) => {
  const $ = _c(11);
  let t0;
  if ($[0] !== dependencies || $[1] !== dependenciesValues) {
    t0 = isDependenciesFilled(dependencies, dependenciesValues);
    $[0] = dependencies;
    $[1] = dependenciesValues;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const dependenciesFilled = t0;
  let t1;
  if ($[3] !== baseDataSource || $[4] !== dependencies || $[5] !== dependenciesFilled || $[6] !== dependenciesValues) {
    t1 = buildDataSource(baseDataSource, dependencies, dependenciesValues, dependenciesFilled);
    $[3] = baseDataSource;
    $[4] = dependencies;
    $[5] = dependenciesFilled;
    $[6] = dependenciesValues;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const dataSource = t1;
  let t2;
  if ($[8] !== dataSource || $[9] !== dependenciesFilled) {
    t2 = {
      dataSource,
      dependenciesFilled
    };
    $[8] = dataSource;
    $[9] = dependenciesFilled;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
};